/**
 * PointsSummary Component
 * 
 * Displays 3 stat cards in a row:
 * - Available Balance (large number, accent color)
 * - Earned Today (with +/- indicator)
 * - Lifetime Earned
 */

import React from 'react';
import './PointsSummary.scss';

interface PointsSummaryProps {
  availableBalance: number;  // from status.total_points
  earnedToday: number;       // calculated
  lifetimeEarned: number;    // calculated
}

export const PointsSummary: React.FC<PointsSummaryProps> = ({
  availableBalance,
  earnedToday,
  lifetimeEarned,
}) => {
  return (
    <div className="points-summary">
      <div className="points-summary-item balance">
        <span className="points-summary-count">{availableBalance.toLocaleString()}</span>
        <span className="points-summary-label">Available Balance</span>
      </div>
      <div className="points-summary-item earned-today">
        <span className={`points-summary-count ${earnedToday >= 0 ? 'positive' : 'negative'}`}>
          {earnedToday >= 0 ? '+' : ''}{earnedToday.toLocaleString()}
        </span>
        <span className="points-summary-label">Earned Today</span>
      </div>
      <div className="points-summary-item lifetime">
        <span className="points-summary-count">{lifetimeEarned.toLocaleString()}</span>
        <span className="points-summary-label">Lifetime Earned</span>
      </div>
    </div>
  );
};

export default PointsSummary;





